import { ChevronRight, Circle, ListChecks } from 'lucide-react';
import type { Mancanza, SchedaDaAprire } from '../../lib/eventi/riepilogo';

type Props = {
  mancanze: Mancanza[];
  onApri: (scheda: SchedaDaAprire) => void;
};

/**
 * Cosa manca perche' l'evento funzioni, con il collegamento alla scheda dove
 * si sistema. Sparisce quando e' tutto a posto.
 */
export function DaCompletare({ mancanze, onApri }: Props) {
  if (mancanze.length === 0) return null;
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/70 p-4">
      <div className="flex items-start gap-3">
        <span className="hidden h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700 sm:flex">
          <ListChecks className="h-4 w-4" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-amber-950">
            Per far partire l'evento {mancanze.length === 1 ? 'manca una cosa' : `mancano ${mancanze.length} cose`}
          </p>
          <ul className="mt-2.5 grid gap-2 md:grid-cols-2">
            {mancanze.map((m) => (
              <li key={m.id}>
                <button
                  type="button"
                  onClick={() => onApri(m.scheda)}
                  className="group flex h-full w-full items-center gap-2.5 rounded-lg border border-amber-200 bg-white/80 px-3 py-2 text-left transition-colors hover:border-amber-300 hover:bg-white"
                >
                  <Circle className="h-4 w-4 flex-shrink-0 text-amber-500" />
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium text-gray-900">{m.testo}</span>
                    <span className="block text-[11px] text-neutral-500">{m.perche}</span>
                  </span>
                  <ChevronRight className="h-4 w-4 flex-shrink-0 text-neutral-400 group-hover:text-neutral-700" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
